var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('div',[_c('ul',{attrs:{"id":"preparationsInstructions"}},_vm._l((_vm.preparationsInstructions),function(item){return _c('li',{key:item},[_vm._v("\n        "+_vm._s(item)+"\n      ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }